<template>
    <div class="modal__overlay" @click.self="$emit('click', $event)">
        <div class="modal">
            <video controls :poster="poster" autoplay="true" >
                <source :src="src" type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
            </video>
        </div>
    </div>
</template>
<script>
export default {
    name: "video-modal",
    props: {
        poster: { type: String, default: "" },
        src: { type: String }
    }
};
</script>
<style scoped>
.modal__overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 960px;
}

.modal > video {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/video-modal.vue